import styled from 'styled-components';

import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import type { EditTopicModalProps } from '../types';
import createTopicUtils from '../utils';
import ViewSetting from '../ViewSetting';

const EditManualTopic = (
  props: EditTopicModalProps & {
    initialTopic: Topic2T<TOPIC_2_TYPE.MANUAL>;
    closeModal: () => void;
  },
) => {
  const target: CreateTopicTarget =
    props.initialTopic.level === 1 ? 'taxonomy' : 'topic';

  const targetTopicAlias = createTopicUtils.getTargetTopicAlias(
    props.initialTopic,
  );

  return (
    <Style>
      <ViewSetting {...props} target={target} targetAlias={targetTopicAlias} />
    </Style>
  );
};

const Style = styled.div`
  min-width: 800px;
`;

export default EditManualTopic;
